import { useRef, useState } from 'react'
import { domToBlob, domToPng } from 'modern-screenshot'
import { showSuccessData } from '@/lib/toast'

export function useShareImage() {
  const cardRef = useRef<HTMLDivElement>(null)
  const [isGenerating, setIsGenerating] = useState(false)
  const generateBlob = async () => {
    if (!cardRef.current) return null
    setIsGenerating(true)
    try {
      return await domToBlob(cardRef.current, {
        scale: 2,
        quality: 1,
      })
    } finally {
      setIsGenerating(false)
    }
  }
  const downloadImage = async (filename: string) => {
    const dataUrl = await domToPng(cardRef.current!, { scale: 2 })
    const link = document.createElement('a')
    link.href = dataUrl
    link.download = filename
    link.click()
    showSuccessData('图片已保存')
  }
  const copyToClipboard = async () => {
    const blob = await generateBlob()
    if (!blob) return
    await navigator.clipboard.write([new ClipboardItem({ 'image/png': blob })])
    showSuccessData('图片已复制')
  }
  return { cardRef, isGenerating, downloadImage, copyToClipboard }
}
